import React, {useEffect, useState} from 'react';

import {useApplicationContext} from '../ApplicationContext';
import {AdConversionStatusDto, EUserGroup} from '../apiClient/Api';
import {AdConversionDialog, AdConversionCloseReason} from './AdConversionDialog';

/** Dauerhaftes Aus („Nicht mehr fragen"). */
const DONT_ASK_KEY = 'adConversion.dontAsk';

/** Aus für diese Browser-Sitzung („Später"). */
const SNOOZE_KEY = 'adConversion.snoozed';

/**
 * Fragt interne Benutzer mit lokalem Passwort nach dem Login, ob sie ihr Konto auf die
 * AD-Anmeldung umstellen wollen.
 *
 * Fragt nur, wenn der Server die Umstellung tatsächlich anbietet (`GET /User/Me/AdConversion`,
 * eligible) — also nie bei Kunden, bereits umgestellten Konten oder abgeschalteter
 * AD-Anbindung. „Später" schweigt für die Sitzung, „Nicht mehr fragen" dauerhaft; die
 * Umstellung bleibt danach über die Sicherheitsseite erreichbar.
 */
export const AdConversionPrompt: React.FC = () => {
    const context = useApplicationContext();
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState<AdConversionStatusDto | null>(null);

    useEffect(() => {
        const group = context.userData?.userGroup;
        if (group === undefined || group === null || group > EUserGroup.OFFICE) return;
        if (localStorage.getItem(DONT_ASK_KEY) === '1') return;
        if (sessionStorage.getItem(SNOOZE_KEY) === '1') return;

        context.api.user
            .userGetAdConversionStatus()
            .then((r) => {
                if (r.data.eligible) {
                    setStatus(r.data);
                    setOpen(true);
                }
            })
            // Bewusst still: die Nachfrage ist ein Angebot, kein Feature mit Fehlerbild.
            .catch(() => undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = (reason: AdConversionCloseReason): void => {
        if (reason === 'later') sessionStorage.setItem(SNOOZE_KEY, '1');
        if (reason === 'never') localStorage.setItem(DONT_ASK_KEY, '1');
        setOpen(false);
    };

    return <AdConversionDialog open={open} onClose={handleClose} asPrompt account={status?.account}/>;
};

export default AdConversionPrompt;
